import { render, staticRenderFns } from "./CommunityListGrid.vue?vue&type=template&id=511213b2&"
import script from "./CommunityListGrid.vue?vue&type=script&lang=js&"
export * from "./CommunityListGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports